import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HandsPraying = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M351.2 4.8c3.2-2 6.6-3.3 10-4.1 4.7-1 9.6-.9 14.1.1 7.7 1.8 14.8 6.5 19.4 13.6l119.9 179.8c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5l-168.8-45c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-84.9c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3-1-4.7-1-9.6.1-14.1 1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9 1.1 4.6 1.2 9.4.1 14.1-.7 3.2-1.9 6.3-3.6 9.3l-86.3 151.2c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-17.7 14.3-32 32-32s32 14.3 32 32v118.3c0 58-39 108.7-95 123.7L40.3 511c-9.6 2.6-19.9.5-27.7-5.5S0 490 0 480v-96c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2v-73.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6 4.6-1.1 9.4-1.2 14.1-.1 3.5.8 6.9 2.1 10 4.1z"
  }));
});
HandsPraying.displayName = 'HandsPraying';
export var HandsPrayingDimensions = {
  height: 512,
  width: 640
};